import React, { useEffect } from 'react';
import ImageLoader from '../images/ImageLoader';

var VideoImage = function VideoImage(props) {
  var _video$value2, _video$value3, _video$value6;

  var _props$video = props.video,
      video = _props$video === void 0 ? {} : _props$video,
      _props$image = props.image,
      image = _props$image === void 0 ? {} : _props$image,
      _props$autoplay = props.autoplay,
      autoplay = _props$autoplay === void 0 ? {} : _props$autoplay,
      _props$displayControl = props.displayControls,
      displayControls = _props$displayControl === void 0 ? {} : _props$displayControl,
      _props$playsound = props.playsound,
      playsound = _props$playsound === void 0 ? {} : _props$playsound,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$isEditing = props.isEditing,
      isEditing = _props$isEditing === void 0 ? false : _props$isEditing;
  var controlsFalg = (displayControls === null || displayControls === void 0 ? void 0 : displayControls.value) ? Number(displayControls === null || displayControls === void 0 ? void 0 : displayControls.value) : 0;
  var autoplayFlag = (autoplay === null || autoplay === void 0 ? void 0 : autoplay.value) ? Number(autoplay === null || autoplay === void 0 ? void 0 : autoplay.value) : 0;
  var playsoundFlag = (playsound === null || playsound === void 0 ? void 0 : playsound.value) ? Number(playsound === null || playsound === void 0 ? void 0 : playsound.value) : 0;
  var _video$value = video.value,
      value = _video$value === void 0 ? {} : _video$value;
  var _value$href = value.href,
      href = _value$href === void 0 ? '' : _value$href;
  var embedURL = href;
  var playList = '';
  var externalLink = '';

  if ((video === null || video === void 0 ? void 0 : (_video$value2 = video.value) === null || _video$value2 === void 0 ? void 0 : _video$value2.linktype) === 'external' && (video === null || video === void 0 ? void 0 : (_video$value3 = video.value) === null || _video$value3 === void 0 ? void 0 : _video$value3.href)) {
    var splitUrl = href.split('/watch?v=');
    playList = splitUrl[splitUrl.length - 1];
    embedURL = splitUrl.join('/embed/');

    if (controlsFalg && autoplayFlag && playsoundFlag) {
      externalLink = '?controls=' + controlsFalg + '&autoplay=' + autoplayFlag + '&mute=' + playsoundFlag + '&loop=1&rel=0&showinfo=0&playlist=' + playList;
    }
  }

  useEffect(function () {
    var _video$value4, _video$value5;

    if ((video === null || video === void 0 ? void 0 : (_video$value4 = video.value) === null || _video$value4 === void 0 ? void 0 : _video$value4.linktype) === 'media' && (video === null || video === void 0 ? void 0 : (_video$value5 = video.value) === null || _video$value5 === void 0 ? void 0 : _video$value5.href)) {
      handleMediaVideo();
    }
  }, [video]);

  var handleMediaVideo = function handleMediaVideo() {
    var videoElement = document.querySelector("#video-frame");
    (playsound === null || playsound === void 0 ? void 0 : playsound.value) ? (videoElement === null || videoElement === void 0 ? void 0 : videoElement.hasAttribute("muted")) ? videoElement === null || videoElement === void 0 ? void 0 : videoElement.removeAttribute("muted") : null : videoElement;
    !(displayControls === null || displayControls === void 0 ? void 0 : displayControls.value) ? (videoElement === null || videoElement === void 0 ? void 0 : videoElement.hasAttribute("controls")) ? videoElement === null || videoElement === void 0 ? void 0 : videoElement.removeAttribute("controls") : null : videoElement;
    !(autoplay === null || autoplay === void 0 ? void 0 : autoplay.value) ? (videoElement === null || videoElement === void 0 ? void 0 : videoElement.hasAttribute("autoplay")) ? videoElement === null || videoElement === void 0 ? void 0 : videoElement.removeAttribute("autoplay") : null : videoElement;
  };

  if (video === null || video === void 0 ? void 0 : (_video$value6 = video.value) === null || _video$value6 === void 0 ? void 0 : _video$value6.href) {
    var _video$value7, _video$value8;

    return /*#__PURE__*/React.createElement("div", {
      className: "cb-videocontainer"
    }, (video === null || video === void 0 ? void 0 : (_video$value7 = video.value) === null || _video$value7 === void 0 ? void 0 : _video$value7.linktype) === 'external' && /*#__PURE__*/React.createElement("iframe", {
      type: "text/html",
      className: "cb-videoimage ".concat(className),
      src: embedURL + externalLink,
      allow: "autoplay",
      frameBorder: 0,
      allowFullScreen: true
    }), (video === null || video === void 0 ? void 0 : (_video$value8 = video.value) === null || _video$value8 === void 0 ? void 0 : _video$value8.linktype) === 'media' && /*#__PURE__*/React.createElement("div", {
      className: "media-video"
    }, /*#__PURE__*/React.createElement("video", {
      id: "video-frame",
      height: "100%",
      width: "100%",
      autoPlay: "true",
      controls: "true",
      muted: "true",
      playsinline: "true",
      loop: "true",
      name: "media"
    }, /*#__PURE__*/React.createElement("source", {
      src: embedURL,
      type: "video/mp4"
    }), "Your browser does not support the video tag.")));
  } else {
    return /*#__PURE__*/React.createElement(ImageLoader, {
      media: image,
      className: "cb-videoimage ".concat(className),
      isEditing: isEditing
    });
  }
};

export default VideoImage;